/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ base: NonNullable<unknown> }} Admin_Billing_Bills_List_Detail_BaseInputs */

const es_admin_billing_bills_list_detail_base = /** @type {(inputs: Admin_Billing_Bills_List_Detail_BaseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Base: ${i?.base}`)
};

const en_admin_billing_bills_list_detail_base = /** @type {(inputs: Admin_Billing_Bills_List_Detail_BaseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Base: ${i?.base}`)
};

/**
* | output |
* | --- |
* | "Base: {base}" |
*
* @param {Admin_Billing_Bills_List_Detail_BaseInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_bills_list_detail_base = /** @type {((inputs: Admin_Billing_Bills_List_Detail_BaseInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Bills_List_Detail_BaseInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_bills_list_detail_base(inputs)
	return en_admin_billing_bills_list_detail_base(inputs)
});
export { admin_billing_bills_list_detail_base as "admin.billing.bills_list.detail_base" }